import { render, staticRenderFns } from "./PenalidadeAbaSancao.vue?vue&type=template&id=43e0964c"
import script from "./PenalidadeAbaSancao.vue?vue&type=script&lang=js"
export * from "./PenalidadeAbaSancao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports